import { render, staticRenderFns } from "./validarcorreo.vue?vue&type=template&id=22f4e4e0&scoped=true"
import script from "./validarcorreo.vue?vue&type=script&lang=js"
export * from "./validarcorreo.vue?vue&type=script&lang=js"
import style0 from "./validarcorreo.vue?vue&type=style&index=0&id=22f4e4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4e4e0",
  null
  
)

export default component.exports